'use strict';

angular.module('licensure.services')
    .factory('Licenses', ['$http', '$q', function ($http, $q) {
        return {
            get: function (args) {
                var d = $q.defer();

                $http
                    .get(apiLocation + '/api/licenses', {
                        params: args
                    })
                    .then(function (response) {
                        d.resolve(response.data);
                    })
                    .catch(function (response) {
                        console.log(response.data);
                        // handle error
                    });

                return d.promise;
            },

            getByID: function (id) {
                var d = $q.defer();

                $http
                    .get(apiLocation + '/api/licenses/' + id, {
                        params: {

                        }
                    })
                    .then(function (response) {
                        d.resolve(response.data);
                    })
                    .catch(function (response) {
                        // handle error
                    });

                return d.promise;
            },

            save: function (license) {
                var d = $q.defer();

                var method = 'POST';
                var url = apiLocation + '/api/licenses/';
                if (!isUndefined(license.id)) {
                    method = 'PUT'
                    url += license.id
                }

                $http({
                    method: method,
                    url: url,
                    data: {
                        license: license,
                        license_rules: license.license_rules,
                        license_request_statuses: license.license_request_statuses,
                        license_category_certification_statuses: license.license_category_certification_statuses,
                        license_category_levels: license.license_category_levels,
                        license_category_certification_attributes: license.license_category_certification_attributes,
                        processes: license.modified_processes
                    }
                })
                    .then(function (response) {
                        d.resolve(response.data);
                    })
                    .catch(function (response) {
                        // handle error
                    });

                return d.promise;
            },

            delete: function (id) {
                var d = $q.defer();

                $http
                    .delete(apiLocation + '/api/licenses/' + id, {
                        params: {

                        }
                    })
                    .then(function (response) {
                        d.resolve(response.data);
                    })
                    .catch(function (response) {
                        // handle error
                    });

                return d.promise;
            }
        }
    }])
;